/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_OpenInputs */



/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {Meeting_Transcript_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_open = /** @type {((inputs?: Meeting_Transcript_OpenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_OpenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Transcript")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription")
	return /** @type {LocalizedString} */ ("Transcript")
});